import React from 'react';
import { customStyle, theme } from './CustomAutocompleteStyle';
import { Autocomplete, Box, InputBase, createStyles } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => createStyles(customStyle));

export const CustomChipsAutocomplete = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const defaultProps = {
    options: props.list,
    getOptionLabel: (option) => {
      if (typeof option === 'string') return option;
      if (typeof props.getOptionLabel === 'function') {
        return props.getOptionLabel(option);
      }
      return option.thematic;
    },
  };

  const inputPlaceholder =
    props.placeholder !== undefined
      ? props.placeholder
      : t('Ajoutez ou sélectionnez une thématique');

  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        {...defaultProps}
        size="small"
        disableCloseOnSelect
        limitTags={5}
        multiple
        freeSolo  
        disabled={props.disabled}
        value={props.value}
       
        inputValue={props.inputValue}
        onInputChange={(_, newInputValue) => {
          if (props.onInputChange) {
            props.onInputChange(newInputValue);
          }
        }}
        isOptionEqualToValue={(option, value) =>
          option.thematic === value.thematic
        }
        onChange={(_, newValues) => {
           const formattedValues = newValues.map((item) => {
            if (typeof item === 'string') {
               return {
                id: 0,
                thematic: item.trim(),
              };
            }
            return item;
          });

          props.callbackFromMultiSelect(formattedValues);
        }}
        className={`${
          props.disabled ? classes.textFieldDisabled : classes.textField
        }`}
        classes={{
          option: classes.option,
          clearIndicatorDirty: classes.clearIndicator,
          popupIndicator: classes.popupIndicator,
        }}
        renderOption={(_props, option) => {
          const label =
            typeof option === 'string' ? option : props.getOptionLabel(option);

          const alreadySelected =
            props.value.findIndex(
              (element) => element.thematic === option.thematic
            ) > -1;

          return (
            <Box
              style={{ display: 'flex', justifyContent: 'space-between' }}
              {..._props}
            >
              <Box>{label}</Box>
              {alreadySelected && (
                <Box>
                  <img
                    style={{ float: 'right' }}
                    src="Images/icon-check.png"
                    alt="icon-check"
                  />
                </Box>
              )}
            </Box>
          );
        }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          return (
            <InputBase
              classes={{ root: classes.root }}
              variant="outlined"
              placeholder={inputPlaceholder}
              {...params.InputProps}
              {...rest}
            />
          );
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => {
            const { key, onDelete } = getTagProps({ index });
            return (
              <span key={key ?? index} className={classes.chip}>
                {typeof props.getOptionLabel === 'function'
                  ? props.getOptionLabel(option)
                  : option.thematic}
                {!props.disabled && (
                  <button
                    type="button"
                    className={classes.chipDelete}
                    onClick={onDelete}
                    onMouseDown={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                    aria-label={t('Supprimer')}
                  >
                    ×
                  </button>
                )}
              </span>
            );
          })
        }
      />
    </ThemeProvider>
  );
};
